import React, {useCallback, useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import BasicSection from '../../components/BasicSection';
import PanelContainer from '../../components/PanelContainer';
import ENDPOINT from '../../constants/endpoints';
import Button from '../../GbsUI/UI/Button';
import TextInput from '../../GbsUI/UI/TextInput';
import './styles.css';
import useApi from '../../hooks/useApi';

const CandidateLinkedInSection = ({candidateId}) => {
  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState('');
  const [approved, setApproved] = useState(false);
  const api = useApi();

  const update = useCallback((data) => {
    setLoading(true);
    api.postRequest(ENDPOINT.ENTITY.CANDIDATE_LINKEDIN, data, {
      handleSuccess: (data) => {
        setApproved(data.approved);
        setUrl(data.url);
      },
      handleComplete: () => {
        setLoading(false);
        toast.success('LinkedIn URL updated successfully');
      }
    });
  }, [url, approved, candidateId]);

  const onApproveChange = useCallback(() => {
    update({
      candidateId,
      url,
      approved: approved ? 0 : 1,
    });
  }, [url, approved, candidateId]);

  const onUpdate = useCallback(() => {
    update({
      candidateId,
      url,
      approved: approved && url.trim() !== '',
    });
  }, [url, approved, candidateId]);

  useEffect(() => {
    api.getRequest(ENDPOINT.ENTITY.CANDIDATE_LINKEDIN, {
      candidateId,
    }, {
      handleSuccess: (data) => {
        setUrl(data.url);
        setApproved(data.approved === 1);
      },
      handleComplete: () => {
        setLoading(false);
      }
    })
  }, []);

  return (
    <PanelContainer styles={{ marginBottom: '10px', paddingTop: '25px' }}>
      <BasicSection title="LinkedIn">
        <div className={'candidate-linkedin'}>
          <TextInput
            label={'LinkedIn URL'}
            containerClassName={'candidate-linkedin__input'}
            help={'The correct format is https://www.linkedin.com/in/username/'}
            value={url}
            placeholder={'https://www.linkedin.com/in/username/'}
            pattern={'https://(www.)?linkedin.com/in/.+'}
            onChange={e => setUrl(e.target.value)}
            onBlur={(e) => {
              const val = e.target.value.trim();

              if (val) {
                try {
                  const url = new URL(val);

                  if (url.protocol !== 'https:') {
                    url.protocol = 'https:';
                  }

                  if (url.hostname !== 'www.linkedin.com') {
                    url.hostname = 'www.linkedin.com';
                  }

                  setUrl(url.toString())
                } catch (e) {
                  const regex = /(www\.)?(linkedin.com)?\/?in\/([\w-]*)\/?/gm;
                  const match = regex.exec(val);

                  if (match) {
                    setUrl(`https://www.linkedin.com/in/${match[3]}`);
                  } else {
                    setUrl(`https://www.linkedin.com/in/${val.replace('/', '')}`);
                  }
                }

              }
            }}
          />
          <Button
            onClick={onUpdate}
            disabled={loading}
          >
            Save
          </Button>
          <Button
            onClick={onApproveChange}
            secondary={approved}
            disabled={loading || !url.trim()}
          >
            {approved ? 'Un-approve' : 'Approve'}
          </Button>
        </div>
      </BasicSection>
    </PanelContainer>
  );
}

export default CandidateLinkedInSection;
